import { COVERGO_ASIA_QA } from "../consts";

export const presales = {
	"presales-studio.qa.asia.covergo.cloud": {
		appConfig: {
			tenantId: "presales",
			appId: "admin_portal",
		},
		envConfig: COVERGO_ASIA_QA,
		fileSystem: {
			bucketName: "covergo-apse1-qa-presales"
		},
	},
}